import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { shape, bool } from 'prop-types';
import { getShippingTemplate } from '../helpers/shipping-helper';
import { productShape, isGraphQlDataEqual } from '../helpers/pod-fulfillment-utils';
import { dataModel } from '../../components/dataModel';
import { EmptyShippingMessage } from '../partials/shipping/EmptyShippingMessage';
import './fulfillment-pod-shipping.scss';

export const FulfillmentPodShipping = React.memo(({ product, isTwoTileEnabled }) => {
  const { customer } = useContext(ExperienceContext);
  const ShippingComponent = getShippingTemplate({ product, customer, isTwoTileEnabled });

  if (!ShippingComponent) { return EmptyShippingMessage; }

  return (<ShippingComponent product={product} isTwoTileEnabled={isTwoTileEnabled} />);
}, isGraphQlDataEqual);

FulfillmentPodShipping.propTypes = {
  product: shape({ productShape }).isRequired,
  isTwoTileEnabled: bool
};

FulfillmentPodShipping.defaultProps = {
  isTwoTileEnabled: false
};

FulfillmentPodShipping.dataModel = dataModel;
